// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    // XNG-Changes: Add a timestamp to the API request to prevent the browser from using cache data
    const timestamp = `time${new Date().getTime()}`;
    props.apiParameter = {
        productId: props.parameter.productId,
        pageSize: 1000,
        expand: ["content", "documents", "specifications", "attributes", "badges"],
        includeAttributes: ["includeOnProduct"],
        additionalQueryStringParameters: { timestamp },
    };
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
